import React, {Component} from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectBodySize extends Component {

  handleChange = (e) => {
    this.props.actions.changeSelectBodySize({
      selectBodySize: e.target.value,
    })
  }

  render() {
    const {  payload } = this.props.systemLabelMastersApi
    if (!payload) {return null}
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    const {selectBodySize} = this.props
    return <div className='searchArea__item'>
      <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.BODY_SIZE}</h3>
      <p className='selectWrap searchArea__item__inner'>
        <select
          className="select"
          value={selectBodySize}
          onChange={this.handleChange}
        >
          <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.ALL}</option>
          {
            systemLabelMasterCollection.getValueList('item','body_size').map(i => {
              return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
            })
          }
        </select>
      </p>
    </div>
  }
}
export default SelectBodySize
